// extracted by mini-css-extract-plugin
export var fileUpload = "_g5-1";
export var modalButton = "_g5-0";